class RTPBestProducts {
  constructor() {
    if (!document.querySelector(".rtp-best-products-section")) return;

    const updatePageDots = (currentPage) => {
      const current = document.querySelector(
        ".rtp-best-products-section .page-dots .current",
      );
      const total = document.querySelector(
        ".rtp-best-products-section .page-dots .total",
      );

      current.textContent = String(currentPage).padStart(2, "0");
      total.textContent = String(mobileFlickity.slides.length).padStart(2, "0");
    };

    const flickityOptions = {
      draggable: true,
      pageDots: false,
      wrapAround: true,
      prevNextButtons: false,
      initialIndex: 0,
    };
    const mobileFlickity = new Flickity(
      ".rtp-best-products-slides.mobile",
      flickityOptions,
    );
    mobileFlickity.on("init", () => updatePageDots(1));
    mobileFlickity.on("change", (index) => updatePageDots(index + 1));
    updatePageDots(mobileFlickity.selectedIndex + 1);

    const prevButton = document.querySelector(
      ".rtp-best-products-section .prev",
    );
    const nextButton = document.querySelector(
      ".rtp-best-products-section .next",
    );

    prevButton.addEventListener("click", () => {
      mobileFlickity.previous();
    });

    nextButton.addEventListener("click", () => {
      mobileFlickity.next();
    });

    // desktop
    const desktopFlickity = new Flickity(".rtp-best-products-slides.desktop", {
      groupCells: 2,
      freeScroll: true,
      pageDots: false,
      wrapAround: true,
      prevNextButtons: true,
      initialIndex: 0,
    });
  }
}

if (typeof RTPBestProducts !== "undefined") {
  new RTPBestProducts();
}
